const getUsersList = (state) => state.usersList;

const getMessagesList = (state) => state.messagesList;

const getMessageToEdit = (state) => state.messageToEdit;

const getMessagesTypesList = (state) => state.messagesTypesList;

const getEditMessageDirty = (state) => state.isEditMessageDirty;

export default {
  getUsersList,
  getMessagesList,
  getMessageToEdit,
  getMessagesTypesList,
  getEditMessageDirty,
};
